import {useCallback, useEffect, useState} from 'react';

import {PinEntry} from '~/features/Auth/PinEntry';
import {useApi} from '~/modules/api';

import {useAuth} from '~/store/hooks';

export const CreatePin = () => {
  const api = useApi();

  const {fetchUser} = useAuth();

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [pin, setPin] = useState('');
  const [confirmPin, setConfirmPin] = useState('');

  const pinValid = pin.length === 6 && pin === confirmPin;

  const onChangePin = useCallback((pin: string) => {
    if (pin.length === 6) {
      setPin(pin);
    }
  }, []);
  const onChangeConfirmPin = useCallback((pin: string) => {
    if (pin.length === 6) {
      setConfirmPin(pin);
    }
  }, []);

  const createPin = useCallback(
    async (pin: string) => {
      setSubmitting(true);
      try {
        const resp = await api.fetch({
          url: '/auth/createPin',
          method: 'POST',
          data: {pinCode: pin},
        });
        if (resp.status === 200) {
          await fetchUser();
        }
      } catch (err) {
        if (err instanceof Error) {
          setError(err.message);
        }
      }
      setSubmitting(false);
    },
    [api, fetchUser],
  );

  useEffect(() => {
    if (pinValid) {
      createPin(pin);
    }
  }, [pin, pinValid, createPin]);

  return (
    <div className="flex flex-col items-center">
      <h3 className="text-subtitlelarge mb-4">
        {!pin ? 'Choose a 6 digit pin code' : 'Confirm your pin code'}
      </h3>

      {!pin && <PinEntry onChangePin={onChangePin} />}
      {!!pin && !confirmPin && <PinEntry onChangePin={onChangeConfirmPin} />}

      {submitting && <span className="loading loading-dots loading-md"></span>}

      {!!error && (
        <div role="alert" className="alert alert-error">
          <span className="text-center">{error}</span>
        </div>
      )}
    </div>
  );
};
